import React from 'react';
import { StyleSheet, View } from 'react-native';

import { IconChevronRight, Skeleton, SkeletonTextBlock, tokens } from '@fhs/ui';

export function TransactionItemSkeleton() {
  return (
    <View
      accessibilityElementsHidden
      accessible={false}
      importantForAccessibility="no-hide-descendants"
      style={styles.container}
    >
      <View style={styles.content}>
        <View style={styles.transactionInfo}>
          <Skeleton style={styles.iconContainer} />
          <SkeletonTextBlock style={styles.transactionInfoSkeleton} lines={2} />
        </View>
        <View style={styles.amountContainer}>
          <Skeleton style={styles.transactionAmountSkeleton} />
          <IconChevronRight
            accessibilityElementsHidden
            aria-hidden
            importantForAccessibility="no-hide-descendants"
            size={20}
            color={tokens.colors.$blackOpacity10}
          />
        </View>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    padding: 16,
    flexDirection: 'row',
  },
  content: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
  },
  transactionInfo: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
  },
  iconContainer: {
    width: 40,
    height: 40,
    borderRadius: 100,
  },
  transactionInfoSkeleton: {
    width: '70%',
    marginLeft: 12,
  },
  amountContainer: {
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'row',
  },
  transactionAmountSkeleton: {
    width: 30,
    height: 14,
  },
});
